import React__default from 'react';
import { Text } from '@shopify/polaris';
import styles from './Title.scss.mjs';

function Title({
  content,
  strong = false
}) {
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles.Title
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: "bodyMd",
    as: "span",
    fontWeight: strong ? 'semibold' : undefined
  }, content));
}

export { Title };
